import api from './api';

export const getWishlist = async () => {
  try {
    const response = await api.get('/users/wishlist/');
    return response.data;
  } catch (err) {
    console.error('Error fetching wishlist:', err);
    throw new Error(err.response?.data?.message || 'Failed to fetch wishlist');
  }
};

export const addToWishlist = async (productId) => {
  try {
    const response = await api.post('/users/wishlist/', { product_id: productId });
    return response.data;
  } catch (err) {
    console.error('Error adding to wishlist:', err);
    throw new Error(err.response?.data?.message || 'Failed to add to wishlist');
  }
};

export const removeFromWishlist = async (productId) => {
  try {
    const response = await api.delete(`/users/wishlist/${productId}/`);
    return response.data;
  } catch (err) {
    console.error('Error removing from wishlist:', err);
    throw new Error(err.response?.data?.message || 'Failed to remove from wishlist');
  }
};
